module.exports = __webpack_public_path__ + "media/images/views/dashboard/silver-0997fc311a1a1f6dd2c5de88e617aa3f.png";